import { FaWhatsapp, FaInstagram, FaTelegram } from "react-icons/fa";

export const providers = {
    whatsapp: {
        label: "WhatsApp",
        icon: FaWhatsapp,
        color: "#25D366",
        providers: {
            zapi: {
                label: "Z-API",
                icon: FaWhatsapp,
                fields: [
                    {
                        name: "instance_id",
                        label: "ID da Instância",
                        required: true,
                        placeholder: "Ex.: 1234567890"
                    },
                    {
                        name: "token",
                        label: "Token",
                        required: true,
                        placeholder: "Ex.: abcd1234efgh5678"
                    },
                    {
                        name: "client_token",       // ✅ corrigido (era security_token)
                        label: "Client Token",
                        required: true,
                        placeholder: "Ex.: Fc1234567890abcd"
                    }
                ]
            },
            cloud_api: {
                label: "API Oficial do WhatsApp (Meta)",
                embeddedSignup: true,
                fields: [
                    {
                        name: "phone_number_id",
                        label: "ID do número de telefone",
                        required: true,
                        placeholder: "Ex.: 1234567890"
                    },
                    {
                        name: "access_token",
                        label: "Token de acesso permanente",
                        type: "password",
                        required: true,
                        placeholder: "Ex.: EAABsbCS..."
                    },
                    { name: "business_account_id", label: "ID da conta empresarial do WhatsApp", required: true },
                    { name: "app_id", label: "ID do aplicativo da Meta", required: true },
                    { name: "app_secret", label: "Chave secreta do aplicativo da Meta", type: "password", required: true },
                    { name: "verify_token", label: "Token de verificação do webhook", type: "password", required: true, help: "Crie uma frase secreta e informe o mesmo valor no painel da Meta." },
                    { name: "country_code", label: "Código do país", placeholder: "55", help: "Usado quando o telefone do lead não possui DDI." },
                    { name: "graph_version", label: "Versão da Graph API", placeholder: "v26.0" }
                ]
            }
        }
    },

    telegram: {
        label: "Telegram",
        icon: FaTelegram,
        color: "#229ED9",
        providers: {
            bot_api: {
                label: "Telegram Bot API",
                fields: [
                    {
                        name: "bot_token",
                        label: "Bot Token",
                        required: true,
                        placeholder: "Ex.: 123456:ABC-DEF..."
                    }
                ]
            }
        }
    },

    instagram: {
        label: "Instagram",
        icon: FaInstagram,
        color: "#E1306C",
        providers: {
            meta: {
                label: "Meta Graph API",
                fields: [
                    {
                        name: "instagram_app_name",
                        label: "Nome do aplicativo na Meta",
                        required: false,
                        placeholder: "Exatamente como aparece no painel da Meta",
                        help: "É o campo “Nome do app do Instagram” exibido no painel da Meta. Não é o nome interno da conexão."
                    },
                    {
                        name: "instagram_app_id",
                        label: "ID do aplicativo na Meta",
                        required: false,
                        placeholder: "Ex.: 1234567890123456",
                        help: "É o campo “ID do app do Instagram” exibido no painel da Meta, por exemplo 1582291770109455."
                    },
                    {
                        name: "app_secret",
                        label: "Chave secreta do aplicativo na Meta",
                        type: "password",
                        required: true,
                        placeholder: "Chave secreta exibida no painel da Meta",
                        help: "Pertence ao app do Fluxo Clínica. Não é o token da conta."
                    },
                    {
                        name: "login_type",
                        label: "Como o token foi gerado",
                        type: "select",
                        options: [
                            { value: "instagram_login", label: "Pelo Instagram — permissões instagram_business_*" },
                            { value: "facebook_login", label: "Pelo Facebook/System User — permissões instagram_*" }
                        ],
                        defaultValue: "instagram_login"
                    },
                    {
                        name: "instagram_business_account_id",
                        label: "ID da conta profissional do Instagram",
                        required: true,
                        placeholder: "Ex.: 17841400000000000",
                        help: "Use o número da conta profissional vinculada, não o ID do usuário no escopo do aplicativo."
                    },
                    {
                        name: "access_token",
                        label: "Token de acesso da conta do Instagram",
                        type: "password",
                        required: true,
                        placeholder: "Token gerado para a conta vinculada",
                        help: "Gerado na seção Gerar tokens de acesso para a conta profissional acima."
                    },
                    {
                        name: "verify_token",
                        label: "Token de verificação do webhook",
                        type: "password",
                        required: true,
                        placeholder: "Crie uma frase secreta para validar o webhook",
                        help: "É criado por você. Copie exatamente este valor para Configurar webhooks > Verificar token no painel da Meta. Não é o token de acesso acima."
                    },
                    {
                        name: "graph_version",
                        label: "Versão da Graph API",
                        required: false,
                        placeholder: "Ex.: v26.0"
                    },
                    {
                        name: "capture_comments",
                        label: "Capturar comentários",
                        type: "checkbox",
                        required: false
                    },
                    {
                        name: "comment_capture_mode",
                        label: "Modo de captura",
                        type: "select",
                        options: [
                            { value: "intent", label: "Somente intenção comercial" },
                            { value: "all", label: "Todos os comentários" }
                        ],
                        defaultValue: "intent"
                    },
                    {
                        name: "auto_private_reply_enabled",
                        label: "Responder comentários automaticamente no Direct",
                        type: "checkbox",
                        required: false,
                        help: "Envia uma única resposta privada para cada comentário capturado. O atendimento manual continua disponível."
                    },
                    {
                        name: "auto_private_reply_intro",
                        label: "Introdução das respostas por intenção",
                        type: "textarea",
                        required: false,
                        placeholder: "Olá, {{usuario}}! Vimos seu comentário: “{{comentario}}”.",
                        help: "O sistema acrescenta a orientação de preço, agendamento, localização, convênio, contato ou procedimento."
                    },
                    {
                        name: "auto_private_reply_message",
                        label: "Mensagem para outras intenções",
                        type: "textarea",
                        required: false,
                        placeholder: "Olá, {{usuario}}! Vimos seu comentário e queremos ajudar.",
                        help: "Fallback para comentários comerciais sem uma categoria específica. Você pode usar {{usuario}} e {{comentario}}."
                    }
                ]
            }
        }
    }
};
